import { PDFViewer } from '@enter/core';
import { mdiClose } from '@mdi/js';
import React, { useContext } from 'react';
import { DialogContext } from 'services';
import * as S from './document.styles';

export function usePdfView() {
    const dialogContext = useContext(DialogContext);

    const handleCloseDialog = (): void => {
        dialogContext.hideDialog?.();
    };

    function openFile(url: string, title: string = 'Document') {
        const dialogProps = {
            onClose: handleCloseDialog,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            renderTitle: title,
        };

        dialogContext.showDialog?.({
            props: dialogProps,
            Component: (
                <S.Wrapper>
                    <S.CloseButton variant="fab-light" onClick={handleCloseDialog}>
                        <S.CloseIcon path={mdiClose} size={1} />
                    </S.CloseButton>
                    <PDFViewer url={url} />
                </S.Wrapper>
            ),
        });
    }

    return [openFile];
}
